// Contract overuse fee: amount charged per visit done above the monthly capacity. Optional: an
// empty field sends null, and the contract charges nothing for the visits above the capacity.
export const toOveruseFee = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') return null
  const parsed = parseFloat(String(value).replace(',', '.'))
  return Number.isFinite(parsed) ? parsed : null
}
